import { ClippedText } from '../../../shared/ui/clipped-text';
import { FolderIcon } from '../../../shared/ui/icons';
import type { TFolderCrumb, TFolderScope } from '../api';
import { SCOPE_ROOT_LABEL, pathText } from '../lib';

// Where a search result is filed, on the line under its name.
export const FolderPath = ({
  scope,
  path,
}: {
  scope: TFolderScope;
  path: readonly TFolderCrumb[];
}) => (
  <span className="flex min-w-0 items-center gap-label font-mono text-micro text-muted">
    <FolderIcon size="sm" />
    <ClippedText text={path.length > 0 ? pathText(path) : SCOPE_ROOT_LABEL[scope]} />
  </span>
);
